import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/index.js';

const ForgotPassword = () => {
  const [orgId, setOrgId] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  // Becomes true only when backend accepts the OTP request
  const [otpStepEnabled, setOtpStepEnabled] = useState(false);
  const navigate = useNavigate();

  const handleRequestOtp = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!orgId || !email) {
      setError('Please enter Organization ID and registered Email.');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.forgotPassword(orgId, email);
      const msg = response?.message || 'OTP sent to your registered email.';
      setMessage(msg);
      setOtpStepEnabled(true);
    } catch (err) {
      console.error('Forgot password error:', err);
      setError(err.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!orgId || !email || !otp || !newPassword || !confirmPassword) {
      setError('Please fill in all fields before resetting your password.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match.');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.resetPassword(orgId, email, otp, newPassword);
      const msg = response?.message || 'Password reset successful. You can now log in with your new password.';
      setMessage(msg);
      // Navigate back to login after a short delay
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      console.error('Reset password error:', err);
      setError(err.message || 'Failed to reset password. Please check your OTP and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: '520px', width: '90%', margin: '20px' }}>
        <div className="login-form-section" style={{ width: '100%', padding: '32px' }}>
          <h2 className="login-title" style={{ marginBottom: '8px' }}>Forgot Password</h2>
          <p style={{ marginTop: 0, marginBottom: '20px', fontSize: '13px', color: '#4b5563' }}>
            Enter your Organization ID and registered Email to receive an OTP, then enter the OTP and new password to reset.
          </p>

          <form>
            {error && (
              <div className="alert alert-danger" style={{ marginBottom: '15px' }}>
                {error}
              </div>
            )}
            {message && !error && (
              <div className="alert alert-success" style={{ marginBottom: '15px' }}>
                {message}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="fp-orgId">Organization ID</label>
              <input
                id="fp-orgId"
                type="text"
                className="form-control"
                value={orgId}
                onChange={(e) => setOrgId(e.target.value)}
                placeholder="Enter organization ID"
              />
            </div>

            <div className="form-group">
              <label htmlFor="fp-email">Registered Email</label>
              <input
                id="fp-email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter registered email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="fp-otp">OTP</label>
              <input
                id="fp-otp"
                type="text"
                className="form-control"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP received in email"
              />
            </div>

            {/* Show password fields only after OTP step is enabled AND OTP is entered */}
            {otpStepEnabled && otp && otp.trim() !== '' && (
              <>
                <div className="form-group">
                  <label htmlFor="fp-newPassword">New Password</label>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      id="fp-newPassword"
                      type={showNewPassword ? "text" : "password"}
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter new password"
                      style={{ paddingRight: '44px', width: '100%' }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(prev => !prev)}
                      title={showNewPassword ? "Hide password" : "Show password"}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#64748b'
                      }}
                    >
                      {showNewPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="fp-confirmPassword">Confirm New Password</label>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      id="fp-confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Re-enter new password"
                      style={{ paddingRight: '44px', width: '100%' }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(prev => !prev)}
                      title={showConfirmPassword ? "Hide password" : "Show password"}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#64748b'
                      }}
                    >
                      {showConfirmPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              </>
            )}

            <div style={{ display: 'flex', justifyContent: otpStepEnabled && otp && otp.trim() !== '' ? 'space-between' : 'flex-start', gap: '10px', marginTop: '10px' }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleRequestOtp}
                style={{ fontSize: '12px' }}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send OTP'}
              </button>
              {otpStepEnabled && otp && otp.trim() !== '' && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleResetPassword}
                  style={{ fontSize: '12px' }}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Reset Password'}
                </button>
              )}
            </div>

            <div style={{ marginTop: '16px', textAlign: 'right' }}>
              <button
                type="button"
                onClick={() => navigate('/login')}
                style={{
                  fontSize: '12px',
                  color: '#2a5298',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  background: 'transparent',
                  border: 'none',
                  padding: 0
                }}
              >
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
